import { Link, useNavigate } from "react-router-dom";

import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Direction, Flex } from "@ntemarked/mittne-components/dist/Flex/Flex";

import { TrafficLightBadge } from "components/atoms/Badge";
import { InfoColumn, InfoColumnValue, InfoRow } from "components/atoms/InfoRow";
import Error from "components/molecules/Error";
import Loading from "components/molecules/Loading";
import { MainLayoutPageHeader } from "components/organisms/MainLayout";
import useDateTime from "hooks/useDateTime";
import { useContentQuery } from "pages/Content/FeedCards/Content.graphql-gen";

export default function ContentPage() {
	const navigate = useNavigate();
	const date = useDateTime();
	const { data, error, loading } = useContentQuery();

	return (
		<>
			<MainLayoutPageHeader
				title={
					<Flex gap="var(--grid-2)">
						Feedkort
						<Link to="create" title="Nytt innhold">
							<FontAwesomeIcon icon={faPlusCircle} />
						</Link>
					</Flex>
				}
			/>
			<Flex style={{ marginTop: "40px", borderRadius: "15px", overflow: "hidden" }} direction={Direction.column}>
				{error && !loading && <Error errorMessage="Feil ved henting av data" />}
				{loading && !data && <Loading />}
				{data?.paginateContent?.items
					?.slice()
					.sort((a, b) => {
						if (!a || !b || a.publishDate === b.publishDate) return 0;
						return Date.parse(a.publishDate as string) < Date.parse(b.publishDate as string) ? 1 : -1;
					})
					.map((content) => (
						<InfoRow
							key={content.id}
							interactive
							onClick={() => {
								navigate("/content/" + content.id);
							}}
						>
							<InfoColumn width="10em">
								<InfoColumnValue>
									<TrafficLightBadge green={content?.published} red={!content?.published}>
										<>{content?.published ? "Publisert" : "Ikke publisert"}</>
									</TrafficLightBadge>
								</InfoColumnValue>
							</InfoColumn>
							<InfoColumn>
								<InfoColumnValue>
									<b>{content?.title}</b> sett av <b>{(content?.uniqueImpressions as number) ?? 0}</b> publisert{" "}
									<b>{date.format(content?.publishDate)}</b>
								</InfoColumnValue>
							</InfoColumn>
						</InfoRow>
					))}
			</Flex>
		</>
	);
}
